module.exports = __webpack_public_path__ + "static/media/dis10-sol.16b7edd4.pdf";